import { useEffect, useMemo, useRef, useState } from "react";

import { CodeOutlined } from "@mui/icons-material";
import Box from "@mui/material/Box";
import isNil from "lodash/isNil";
import ToggleIconButton from "../../_src_shared/buttons/ToggleIconButton";
import EnvLogo from "../../components/env/EnvLogo";
import Flx from "../../components/layout/Flx";
import Htag from "../../components/typography/Htag";
import Txt from "../../components/typography/Txt";
import { loanSizerTypeEnums } from "../../config/enums/loanSizerTypeEnums";
import LoanIntakePricingSizerForm from "./LoanIntakePricingSizerForm";
import LoanIntakePricingSizerResultsCard from "./LoanIntakePricingSizerResultsCard";

const LoanIntakePricingSizerScreen = ({ showLogo, type }) => {
  const containerRef = useRef(null);
  const resultsCardRef = useRef(null);
  const [results, setResults] = useState(null);

  const [formSpy, setFormSpy] = useState(false);

  const isHandsomeHomebuyer = useMemo(() => {
    if (type === loanSizerTypeEnums.HANDSOME_HOME_BUYER) {
      return true;
    }
    return false;
  }, [type]);

  const isResilender = useMemo(() => {
    if (isNil(type)) {
      return true;
    }
    return false;
  }, [type]);

  useEffect(() => {
    if (results != null && resultsCardRef.current) {
      resultsCardRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [results]);
  return (
    <Box
      ref={containerRef}
      sx={{
        display: "flex",
        flexDirection: "column",
        background: "#f5f5f5",
        position: "absolute",
        top: 0,
        left: 0,
        px: 0,
        overflowY: "auto",
        width: "100%",
        height: "100%",
        hr: {
          borderColor: "#f5f5f5",
        },
      }}
    >
      <Flx center column sx={{ pt: 3, pb: 0, px: 2 }}>
        {showLogo && <EnvLogo type={type} maxHeight={86} sx={{ mb: 2 }} />}
        {isResilender ? (
          <Htag h1 sx={{ fontSize: "36px", lineHeight: 1.5 }}>
            RTL Sizer
          </Htag>
        ) : null}
        {isHandsomeHomebuyer ? (
          <Htag
            h1
            sx={{ fontSize: "36px", lineHeight: 1.5, textAlign: "center" }}
          >
            Fix and Flip Calculator
          </Htag>
        ) : null}
        <Txt>Enter all fields to check leverage and pricing for scenario.</Txt>
        <ToggleIconButton
          color={formSpy ? "primary" : "secondary"}
          sx={{ mt: 2, position: "fixed", zIndex: 1111, right: 36, bottom: 16 }}
          onClick={setFormSpy}
        >
          <CodeOutlined />
        </ToggleIconButton>
      </Flx>
      <Flx
        wrap
        jc
        sx={{
          pt: 3,
          px: 1.4,
          pb: 12,
          gap: 2,
        }}
      >
        <LoanIntakePricingSizerForm
          formSpy={formSpy}
          setResults={setResults}
          type={type}
          isHandsomeHomebuyer={isHandsomeHomebuyer}
        />
        <Box ref={resultsCardRef}>
          <LoanIntakePricingSizerResultsCard
            formSpy={formSpy}
            results={results}
            isHandsomeHomebuyer={isHandsomeHomebuyer}
          />
        </Box>
      </Flx>
    </Box>
  );
};

export default LoanIntakePricingSizerScreen;
